import React, { useEffect, useState, useContext, useReducer } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { FormDataContext } from "./FormDataContext";
import "../Style/Page3.css";
import { APIService } from "../api";
import { findCoursePlan } from "../utilities/coursePlan";

const TEN_MINUTES_MS = 10 * 60 * 1000;

const initialFormState = {
    selectedCourse: "",
    discount: "",
    hasDiscount: false,
    hasDiscount1: false,
    lastActivityTime: null,
    hasOtherStudent: false,
    other_student: "",
    paymentMethod: "",
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.field]: action.value };
        case "SET_SELECTED_COURSE":
            return { ...state, selectedCourse: action.payload };
        case "SET_DISCOUNT":
            return { ...state, discount: action.payload };
        case "SET_HAS_DISCOUNT":
            return {
                ...state,
                hasDiscount: action.payload,
                discount: action.payload ? state.discount : "",
            };
        case "SET_HAS_DISCOUNT1":
            return {
                ...state,
                hasDiscount1: action.payload,
            };
        case "SET_HAS_OTHER_STUDENT":
            return {
                ...state,
                hasOtherStudent: action.payload,
                other_student: action.payload ? state.other_student : "",
            };
        case "SET_OTHER_STUDENT":
            return {
                ...state,
                other_student: action.payload,
            };
        case "SET_PAYMENT_METHOD":
            return {
                ...state,
                paymentMethod: action.payload,
            };
        case "UPDATE_ACTIVITY_TIME":
            return { ...state, lastActivityTime: action.payload };
        case "RESET_LOCAL_STATE":
            return initialFormState;
        default:
            return state;
    }
};

const Page3 = () => {
    const navigate = useNavigate();
    const { formData, updateFormData } = useContext(FormDataContext);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [price, setPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);

    const [state, dispatch] = useReducer(reducer, initialFormState);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const productsData = await APIService.getProducts();
                if (Array.isArray(productsData)) {
                    setProducts(productsData);
                } else {
                    throw new Error(productsData.message || "Սխալ տվյալներ են ստացվել։");
                }
            } catch (error) {
                const message =
                    error?.response?.data?.message ||
                    error.message ||
                    "Սխալ ապրանքներ բեռնելիս։";
                console.error("Error fetching products:", message);
                alert(message);
                setProducts([]);
            }
        };

        fetchProducts();
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });

        if (formData && formData.selectedCourse) {
            const savedState = {
                selectedCourse: formData.selectedCourse,
                discount: formData.discount || "",
                hasDiscount: formData.hasDiscount || false,
                hasDiscount1: formData.hasDiscount1 || false,
                hasOtherStudent: formData.hasOtherStudent || false,
                other_student: formData.other_student || "",
                paymentMethod: formData.paymentMethod || "",
                selectedDate: formData.selectedDate || "",
                lastActivityTime: formData.lastActivityTime || new Date().getTime(),
            };

            Object.entries(savedState).forEach(([key, value]) => {
                dispatch({
                    type: "SET_FIELD",
                    field: key,
                    value: value,
                });
            });

            const savedProduct = products.find(
                (product) => product.name === savedState.selectedCourse
            );

            if (savedProduct) {
                setSelectedProduct(savedProduct);
                setPrice(savedProduct.price);
            }
        }
    }, [products]);
    useEffect(() => {
        if (state.hasDiscount) {
            const finalPrice = Number(state.discount) || 0;
            setTotalPrice(finalPrice);
        } else {
            setTotalPrice(price);
        }
    }, [state.discount, state.hasDiscount, price]);

    useEffect(() => {
        const checkTimer = setInterval(() => {
            const currentTime = new Date().getTime();
            if (state.lastActivityTime) {
                const timeDiff = currentTime - state.lastActivityTime;
                if (timeDiff >= TEN_MINUTES_MS) {
                    dispatch({ type: "RESET_LOCAL_STATE" });
                    updateFormData({});
                    setSelectedProduct(null);
                    setPrice(0);
                    setTotalPrice(0);
                }
            }
        }, 5000);
        return () => clearInterval(checkTimer);
    }, [state.lastActivityTime]);

    const updateLastActivity = () => {
        dispatch({
            type: "UPDATE_ACTIVITY_TIME",
            payload: new Date().getTime(),
        });
    };

    const handleCourseChange = (selectedOption) => {
        updateLastActivity();
        const selectedProduct = products.find(
            (product) => product.id === selectedOption.value
        );
        dispatch({
            type: "SET_SELECTED_COURSE",
            payload: selectedProduct ? selectedProduct.name : "",
        });
        setSelectedProduct(selectedProduct);
        setPrice(selectedProduct ? selectedProduct.price : 0);
    };

    const handleDiscountChange = (e) => {
        updateLastActivity();
        dispatch({
            type: "SET_DISCOUNT",
            payload: e.target.value.replace(/[^0-9]/g, ""),
        });
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleSubmit = () => {
        updateLastActivity();
        if (!selectedProduct) {
            alert("Խնդրում ենք ընտրել դասընթացը՝ շարունակելու համար։");
            return;
        }

        if (!state.paymentMethod) {
            alert("Խնդրում ենք ընտրել վճարման եղանակը");
            return;
        }

        if (state.hasOtherStudent && !state.other_student.trim()) {
            alert("Խնդրում ենք լրացնել ուսանողի անունը, ազգանունը");
            return;
        }
        updateFormData({
            ...state,
            // Display-only copy for Page4/Page5; the backend re-resolves it from selectedCourse.
            coursePlan: findCoursePlan(products, selectedProduct.name),
            originalPrice: price,
            totalPrice,
            lastActivityTime: new Date().getTime(),
        });

        navigate("/page4");
    };

    return (
        <div className="page3">
            <div className="container">

                {/* 🟧 Դասընթացի ընտրություն */}
                <div className="form-group">
                    <Select
                        className="form-input"
                        options={products.map((product) => ({
                            value: product.id,
                            label: product.name,
                        }))}
                        onChange={handleCourseChange}
                        placeholder="Ընտրել դասընթացը"
                        value={
                            selectedProduct
                                ? {
                                    value: selectedProduct.id,
                                    label: `${selectedProduct.name} `,
                                }
                                : null
                        }
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                    />
                </div>

                {/* 🟧 Ցանկանում եմ օգտվել սոցվճարի հետվերադարձից */}
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="hasDiscount1"
                        checked={state.hasDiscount1}
                        onChange={(e) =>
                            dispatch({ type: "SET_HAS_DISCOUNT1", payload: e.target.checked })
                        }
                    />
                    <label htmlFor="hasDiscount1">
                        Ցանկանում եմ օգտվել սոցվճարի հետվերադարձից
                    </label>
                </div>

                {/* 🟧 Զեղչ */}
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="hasDiscount"
                        checked={state.hasDiscount}
                        onChange={(e) =>
                            dispatch({ type: "SET_HAS_DISCOUNT", payload: e.target.checked })
                        }
                    />
                    <label htmlFor="hasDiscount">Հատուկ գնառաջարկ</label>
                </div>

                {/* 🟧 Զեղչի գումարի ինփութ — սա այն գումարն է, որով նվազում է գինը, ոչ թե վերջնական գինը */}
                {state.hasDiscount && (
                    <div className="form-group">
                        <label htmlFor="hasDiscount">Սահմանել վերջնական գինը</label>
                        <input
                            className="form-input"
                            type="number"
                            min="0"
                            placeholder="Օրինակ՝ 10000"
                            value={state.discount}
                            onChange={handleDiscountChange}
                        />
                    </div>
                )}

                {/* 🟦 Այլ ուսանողի պայմանագիր checkbox */}
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="hasOtherStudent"
                        checked={state.hasOtherStudent}
                        onChange={(e) =>
                            dispatch({
                                type: "SET_HAS_OTHER_STUDENT",
                                payload: e.target.checked,
                            })
                        }
                    />
                    <label htmlFor="hasOtherStudent">
                        Վճարումը կատարում եմ այլ անձի համար
                    </label>
                </div>

                {/* 🟦 Այլ ուսանողի անվան input */}
                {state.hasOtherStudent && (
                    <div className="form-group">
                        <label>Ուսանողի անուն, ազգանուն</label>
                        <input
                            className="form-input"
                            type="text"
                            name="other_student"
                            placeholder="Օրինակ՝ Անի Մկրտչյան"
                            value={state.other_student}
                            onChange={(e) =>
                                dispatch({
                                    type: "SET_OTHER_STUDENT",
                                    payload: e.target.value,
                                })
                            }
                        />
                    </div>
                )}

                {/* 🟩 Վճարման եղանակ */}
                <div className="form-group">
                    <label><strong>Վճարման եղանակը</strong></label>

                    <div>
                        <label>
                            <input
                                type="radio"
                                name="paymentMethod"
                                value="full"
                                checked={state.paymentMethod === "full"}
                                onChange={(e) =>
                                    dispatch({
                                        type: "SET_PAYMENT_METHOD",
                                        payload: e.target.value,
                                    })
                                }
                            />
                            Միանվագ
                        </label>
                    </div>

                    <div>
                        <label>
                            <input
                                type="radio"
                                name="paymentMethod"
                                value="monthly"
                                checked={state.paymentMethod === "monthly"}
                                onChange={(e) =>
                                    dispatch({
                                        type: "SET_PAYMENT_METHOD",
                                        payload: e.target.value,
                                    })
                                }
                            />
                            Մաս մաս՝ ամսական վճարումներ կատարելով մինչև դասընթացի ավարտը
                        </label>
                    </div>

                    <div>
                        <label>
                            <input
                                type="radio"
                                name="paymentMethod"
                                value="paylater"
                                checked={state.paymentMethod === "paylater"}
                                onChange={(e) =>
                                    dispatch({
                                        type: "SET_PAYMENT_METHOD",
                                        payload: e.target.value,
                                    })
                                }
                            />
                            Հետվճարային՝ RocketLine, PayLater, PartPay, AmeriaPay
                        </label>
                    </div>
                </div>

                {/* 🟧 Գին */}
                <p className="Pprive">Ընդհանուր արժեք՝ {totalPrice} ֏</p>

                {/* 🟧 Կոճակներ */}
                <div className="btn_b_n">
                    <button type="button" className="submit-btn" onClick={handleBack}>
                        Նախորդ էջ
                    </button>

                    <button type="button" className="submit-btn" onClick={handleSubmit}>
                        Հաջորդ էջ
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Page3;
